var _rect, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEpgListSkeletonMobile = function SvgEpgListSkeletonMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 444,
    fill: "none",
    viewBox: "0 0 360 444"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 16,
    x: 16,
    y: 4,
    fill: "#1A1A1A",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M16 40h128v72H16z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M16 40h128v72H16z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 20,
    x: 24,
    y: 76,
    fill: "#29D3CE",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.996 90v-8.4h1.608l4.956 6.048h-.78V81.6h1.92V90h-1.596l-4.968-6.048h.78V90zm12.631.096q-1.032 0-1.836-.432a3.36 3.36 0 0 1-1.26-1.176 3.26 3.26 0 0 1-.456-1.716q0-.972.456-1.716a3.24 3.24 0 0 1 1.26-1.176q.804-.432 1.836-.432 1.02 0 1.824.432.804.42 1.26 1.164t.456 1.728q0 .96-.456 1.716a3.25 3.25 0 0 1-1.26 1.176q-.804.432-1.824.432m0-1.536q.468 0 .84-.216t.588-.612q.216-.408.216-.96 0-.564-.216-.96a1.55 1.55 0 0 0-.588-.612 1.64 1.64 0 0 0-.84-.216q-.468 0-.84.216a1.63 1.63 0 0 0-.6.612q-.216.396-.216.96 0 .552.216.96.228.396.6.612t.84.216M55.72 90l-2.328-6.456h1.764l1.932 5.556h-.84l2.016-5.556h1.584l1.956 5.556h-.84l1.992-5.556h1.656L62.27 90h-1.812l-1.716-4.764h.552L57.519 90z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M24 102a2 2 0 0 1 2-2h108a2 2 0 1 1 0 4H26a2 2 0 0 1-2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 24,
    y: 100,
    fill: "#29D3CE",
    rx: 2
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 40h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.09,
    d: "M144 40h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 40h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 40h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.09,
    d: "M144 40h200v72H144z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EEE",
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.162 63v-9.8h4.242q1.315 0 2.268.434.952.42 1.47 1.218t.518 1.904q0 1.092-.518 1.89t-1.47 1.232q-.953.42-2.268.42h-2.982l1.008-1.022V63zm2.268-3.472-1.008-1.078h2.856q1.05 0 1.568-.448t.518-1.246q0-.812-.518-1.26t-1.568-.448h-2.856l1.008-1.078zM163.112 63v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.741-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.897 0-1.456.518-.546.504-.546 1.582V63zm9.503.112q-1.203 0-2.142-.504a3.9 3.9 0 0 1-1.47-1.372q-.532-.882-.532-2.002 0-1.134.532-2.002a3.8 3.8 0 0 1 1.47-1.372q.939-.504 2.142-.504 1.19 0 2.128.504a3.7 3.7 0 0 1 1.47 1.358q.532.868.532 2.016 0 1.12-.532 2.002a3.8 3.8 0 0 1-1.47 1.372q-.937.504-2.128.504m0-1.792q.546 0 .98-.252t.686-.714q.252-.475.252-1.12 0-.658-.252-1.12a1.8 1.8 0 0 0-.686-.714 1.9 1.9 0 0 0-.98-.252q-.545 0-.98.252a1.9 1.9 0 0 0-.7.714q-.252.462-.252 1.12 0 .645.252 1.12.267.462.7.714.435.252.98.252m9.132 4.508a8 8 0 0 1-2.058-.266q-.98-.252-1.638-.77l.868-1.568q.477.392 1.204.616.742.238 1.456.238 1.163 0 1.68-.518.532-.518.532-1.54v-1.134l.14-1.89-.028-1.904v-1.624h2.072v6.272q0 2.1-1.092 3.094t-3.136.994m-.336-3.192q-1.05 0-1.904-.448a3.7 3.7 0 0 1-1.358-1.274q-.504-.825-.504-1.918 0-1.106.504-1.918.519-.825 1.358-1.274a4.04 4.04 0 0 1 1.904-.448q.952 0 1.68.392.729.378 1.134 1.19.406.798.406 2.058 0 1.246-.406 2.058-.405.798-1.134 1.19t-1.68.392m.434-1.792q.575 0 1.022-.224a1.76 1.76 0 0 0 .7-.658 1.84 1.84 0 0 0 .252-.966q0-.56-.252-.966a1.67 1.67 0 0 0-.7-.644 2.14 2.14 0 0 0-1.022-.238q-.573 0-1.022.238a1.77 1.77 0 0 0-.714.644q-.252.406-.252.966 0 .546.252.966.267.42.714.658.449.224 1.022.224M188.008 63v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.743-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.896 0-1.456.518-.546.504-.546 1.582V63zm10.102 0v-1.47l-.14-.322v-2.632q0-.7-.434-1.092-.42-.392-1.302-.392-.602 0-1.19.196-.573.182-.98.504l-.784-1.526q.617-.434 1.484-.672a6.6 6.6 0 0 1 1.764-.238q1.722 0 2.674.812t.952 2.534V63zm-2.296.112q-.882 0-1.512-.294-.63-.307-.966-.826A2.1 2.1 0 0 1 193 60.83q0-.672.322-1.176.336-.504 1.05-.784.714-.294 1.862-.294h2.002v1.274h-1.764q-.77 0-1.064.252a.82.82 0 0 0-.28.63q0 .42.322.672.337.238.91.238.546 0 .98-.252.435-.266.63-.77l.336 1.008a1.95 1.95 0 0 1-.868 1.106q-.63.378-1.624.378m15.963-7.756q.896 0 1.582.364.7.35 1.092 1.092.406.727.406 1.876V63h-2.184v-3.976q0-.91-.378-1.344t-1.064-.434q-.476 0-.854.224-.378.21-.588.644t-.21 1.106V63h-2.184v-3.976q0-.91-.378-1.344-.364-.434-1.05-.434-.476 0-.854.224-.378.21-.588.644t-.21 1.106V63h-2.184v-7.532h2.086v2.058l-.392-.602q.392-.77 1.106-1.162.728-.405 1.652-.406 1.037 0 1.806.532.784.518 1.036 1.596l-.77-.21a3.03 3.03 0 0 1 1.204-1.4q.84-.518 1.918-.518M222.963 63v-7.952h-3.136V53.2h8.54v1.848h-3.136V63zm6.471 0v-7.532h2.184V63zm1.092-8.582q-.603 0-.98-.35a1.14 1.14 0 0 1-.378-.868q0-.518.378-.868.377-.35.98-.35.602 0 .98.336.378.322.378.84 0 .546-.378.91-.365.35-.98.35m6.199 8.694q-1.33 0-2.072-.672-.742-.686-.742-2.03v-6.608h2.184v6.58q0 .476.252.742.252.252.686.252.518 0 .882-.28l.588 1.54a2.5 2.5 0 0 1-.812.364q-.462.112-.966.112m-3.976-5.796v-1.68h5.222v1.68zm6.98 5.684V52.612h2.184V63zm7.949.112q-1.288 0-2.268-.504a3.74 3.74 0 0 1-1.498-1.372q-.532-.882-.532-2.002 0-1.134.518-2.002a3.7 3.7 0 0 1 1.442-1.372q.909-.504 2.058-.504 1.106 0 1.988.476a3.45 3.45 0 0 1 1.414 1.344q.518.868.518 2.086 0 .126-.014.294l-.028.294h-6.118v-1.274h4.97l-.84.378a2.1 2.1 0 0 0-.238-1.022 1.7 1.7 0 0 0-.658-.672 1.87 1.87 0 0 0-.98-.252 1.94 1.94 0 0 0-.994.252q-.42.238-.658.686-.238.435-.238 1.036v.336q0 .616.266 1.092.28.462.77.714.504.238 1.176.238.602 0 1.05-.182.462-.182.84-.546l1.162 1.26q-.519.588-1.302.91-.785.308-1.806.308"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M153.08 81v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64V81zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21V76.1h1.09v1.04zm0 3.86v-1.05h1.09V81zm4.672.09q-.45 0-.89-.09a4.2 4.2 0 0 1-.82-.28 2.9 2.9 0 0 1-.68-.47l.32-.67q.48.4.99.58t1.07.18q.48 0 .83-.14.35-.15.54-.43.2-.29.2-.72 0-.62-.41-.94-.411-.32-1.2-.32h-1.05v-.73h.95q.46 0 .8-.15.34-.16.53-.45.19-.3.19-.72 0-.56-.37-.84-.37-.29-1.01-.29-.54 0-1.03.19t-.91.62l-.32-.67a2.7 2.7 0 0 1 1.02-.66q.62-.23 1.28-.23.68 0 1.16.22.489.21.75.62.27.4.27.97 0 .63-.35 1.09t-.95.64v-.06q.46.08.79.32.33.23.51.59.19.36.19.84 0 .62-.3 1.07-.29.45-.83.69t-1.27.24m6.206 0q-.46 0-.89-.1a3.5 3.5 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59t1.05.19q.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.38.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14q.26-.38.69-.6.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2a2.04 2.04 0 0 1-.83.8q-.53.28-1.27.28m6.272-2.41v-.7h2.8v.7zm7.274 2.32v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64V81zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21V76.1h1.09v1.04zm0 3.86v-1.05h1.09V81zm4.882.09q-.46 0-.89-.1a3.4 3.4 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59.489.19 1.05.19.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.381.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14q.26-.38.69-.6.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m5.876 0q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.831 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.399.7 1.23.7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M317.159 52.075a9.77 9.77 0 0 1 12.992.854c3.853 3.905 3.853 10.237 0 14.142a9.774 9.774 0 0 1-13.953 0 1.01 1.01 0 0 1 0-1.415.977.977 0 0 1 1.394 0 7.82 7.82 0 0 0 11.164 0c3.082-3.124 3.082-8.19 0-11.313a7.82 7.82 0 0 0-10.188-.84l.485.492a.505.505 0 0 1-.281.855l-3.244.47a.5.5 0 0 1-.562-.57l.463-3.29a.495.495 0 0 1 .843-.284zm4.08 3.925c.189 0 .374.052.535.15l4.848 2.967a1.037 1.037 0 0 1 0 1.766l-4.848 2.966a1.026 1.026 0 0 1-1.564-.883v-5.933c0-.57.461-1.033 1.029-1.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 40h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.03,
    d: "M16 40h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 40h200v72H144z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M16 120h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M16 120h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M16 120h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M16 120h128v72H16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 120h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 120h200v72H144z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EEE",
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.162 143v-9.8h4.242q1.315 0 2.268.434.952.42 1.47 1.218t.518 1.904q0 1.092-.518 1.89t-1.47 1.232q-.953.42-2.268.42h-2.982l1.008-1.022V143zm2.268-3.472-1.008-1.078h2.856q1.05 0 1.568-.448t.518-1.246q0-.811-.518-1.26t-1.568-.448h-2.856l1.008-1.078zm7.682 3.472v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.741-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.897 0-1.456.518-.546.504-.546 1.582V143zm9.503.112q-1.203 0-2.142-.504a3.9 3.9 0 0 1-1.47-1.372q-.532-.882-.532-2.002 0-1.134.532-2.002a3.8 3.8 0 0 1 1.47-1.372q.939-.504 2.142-.504 1.19 0 2.128.504a3.7 3.7 0 0 1 1.47 1.358q.532.869.532 2.016 0 1.12-.532 2.002a3.8 3.8 0 0 1-1.47 1.372q-.937.504-2.128.504m0-1.792q.546 0 .98-.252t.686-.714q.252-.476.252-1.12 0-.658-.252-1.12a1.8 1.8 0 0 0-.686-.714 1.9 1.9 0 0 0-.98-.252q-.545 0-.98.252a1.9 1.9 0 0 0-.7.714q-.252.462-.252 1.12 0 .644.252 1.12.267.462.7.714.435.252.98.252m9.132 4.508a8 8 0 0 1-2.058-.266q-.98-.252-1.638-.77l.868-1.568q.477.392 1.204.616.742.238 1.456.238 1.163 0 1.68-.518.532-.518.532-1.54v-1.134l.14-1.89-.028-1.904v-1.624h2.072v6.272q0 2.1-1.092 3.094t-3.136.994m-.336-3.192q-1.05 0-1.904-.448a3.7 3.7 0 0 1-1.358-1.274q-.504-.826-.504-1.918 0-1.106.504-1.918a3.56 3.56 0 0 1 1.358-1.274 4.03 4.03 0 0 1 1.904-.448q.952 0 1.68.392.729.378 1.134 1.19.406.798.406 2.058 0 1.246-.406 2.058-.405.798-1.134 1.19t-1.68.392m.434-1.792q.575 0 1.022-.224.448-.238.7-.658a1.84 1.84 0 0 0 .252-.966q0-.56-.252-.966a1.66 1.66 0 0 0-.7-.644 2.14 2.14 0 0 0-1.022-.238q-.573 0-1.022.238a1.77 1.77 0 0 0-.714.644 1.8 1.8 0 0 0-.252.966q0 .546.252.966.267.42.714.658.449.224 1.022.224m6.163 2.156v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.743-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.896 0-1.456.518-.546.504-.546 1.582V143zm10.102 0v-1.47l-.14-.322v-2.632q0-.7-.434-1.092-.42-.392-1.302-.392-.602 0-1.19.196a3 3 0 0 0-.98.504l-.784-1.526q.617-.433 1.484-.672a6.6 6.6 0 0 1 1.764-.238q1.722 0 2.674.812t.952 2.534V143zm-2.296.112q-.882 0-1.512-.294a2.35 2.35 0 0 1-.966-.826 2.1 2.1 0 0 1-.336-1.162q0-.672.322-1.176.336-.504 1.05-.784.714-.294 1.862-.294h2.002v1.274h-1.764q-.77 0-1.064.252a.82.82 0 0 0-.28.63q0 .42.322.672.337.238.91.238.546 0 .98-.252.435-.266.63-.77l.336 1.008a1.95 1.95 0 0 1-.868 1.106q-.63.378-1.624.378m15.963-7.756q.896 0 1.582.364.7.35 1.092 1.092.406.728.406 1.876V143h-2.184v-3.976q0-.91-.378-1.344t-1.064-.434q-.476 0-.854.224-.378.21-.588.644t-.21 1.106V143h-2.184v-3.976q0-.91-.378-1.344-.364-.434-1.05-.434-.476 0-.854.224-.378.21-.588.644t-.21 1.106V143h-2.184v-7.532h2.086v2.058l-.392-.602q.392-.77 1.106-1.162.728-.406 1.652-.406 1.037 0 1.806.532.784.518 1.036 1.596l-.77-.21a3.02 3.02 0 0 1 1.204-1.4q.84-.518 1.918-.518M222.963 143v-7.952h-3.136V133.2h8.54v1.848h-3.136V143zm6.471 0v-7.532h2.184V143zm1.092-8.582q-.603 0-.98-.35a1.14 1.14 0 0 1-.378-.868q0-.518.378-.868.377-.35.98-.35.602 0 .98.336.378.323.378.84 0 .546-.378.91-.365.35-.98.35m6.199 8.694q-1.33 0-2.072-.672-.742-.686-.742-2.03v-6.608h2.184v6.58q0 .476.252.742.252.252.686.252.518 0 .882-.28l.588 1.54q-.336.238-.812.364a4 4 0 0 1-.966.112m-3.976-5.796v-1.68h5.222v1.68zm6.98 5.684v-10.388h2.184V143zm7.949.112q-1.288 0-2.268-.504a3.74 3.74 0 0 1-1.498-1.372q-.532-.882-.532-2.002 0-1.134.518-2.002a3.7 3.7 0 0 1 1.442-1.372q.909-.504 2.058-.504 1.106 0 1.988.476a3.45 3.45 0 0 1 1.414 1.344q.518.868.518 2.086 0 .126-.014.294l-.028.294h-6.118v-1.274h4.97l-.84.378a2.1 2.1 0 0 0-.238-1.022 1.7 1.7 0 0 0-.658-.672 1.87 1.87 0 0 0-.98-.252 1.94 1.94 0 0 0-.994.252q-.42.238-.658.686-.238.434-.238 1.036v.336q0 .617.266 1.092.28.462.77.714.504.238 1.176.238.602 0 1.05-.182.462-.181.84-.546l1.162 1.26q-.519.588-1.302.91-.785.308-1.806.308"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M153.08 161v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V161zm4.672.09q-.45 0-.89-.09a4.3 4.3 0 0 1-.82-.28 2.9 2.9 0 0 1-.68-.47l.32-.67q.48.4.99.58t1.07.18q.48 0 .83-.14.35-.15.54-.43.2-.29.2-.72 0-.62-.41-.94-.411-.32-1.2-.32h-1.05v-.73h.95q.46 0 .8-.15.34-.16.53-.45.19-.3.19-.72 0-.56-.37-.84-.37-.29-1.01-.29-.54 0-1.03.19t-.91.62l-.32-.67a2.7 2.7 0 0 1 1.02-.66q.62-.23 1.28-.23.68 0 1.16.22.489.21.75.62.27.4.27.97 0 .63-.35 1.09a1.8 1.8 0 0 1-.95.64v-.06q.46.08.79.32.33.23.51.59.19.36.19.84 0 .62-.3 1.07-.29.45-.83.69t-1.27.24m6.206 0q-.46 0-.89-.1a3.5 3.5 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59t1.05.19q.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.38.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m6.272-2.41v-.7h2.8v.7zm7.274 2.32v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V161zm4.882.09q-.46 0-.89-.1a3.4 3.4 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59.489.19 1.05.19.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.381.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m5.876 0q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.831 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.399.7 1.23.7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 120h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.03,
    d: "M16 120h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 120h200v72H144z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    filter: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M16 200h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M16 200h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M16 200h128v72H16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 200h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 200h200v72H144z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EEE",
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.162 223v-9.8h4.242q1.315 0 2.268.434.952.42 1.47 1.218t.518 1.904q0 1.092-.518 1.89t-1.47 1.232q-.953.42-2.268.42h-2.982l1.008-1.022V223zm2.268-3.472-1.008-1.078h2.856q1.05 0 1.568-.448t.518-1.246q0-.811-.518-1.26t-1.568-.448h-2.856l1.008-1.078zm7.682 3.472v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.741-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.897 0-1.456.518-.546.504-.546 1.582V223zm9.503.112q-1.203 0-2.142-.504a3.9 3.9 0 0 1-1.47-1.372q-.532-.882-.532-2.002 0-1.134.532-2.002a3.8 3.8 0 0 1 1.47-1.372q.939-.504 2.142-.504 1.19 0 2.128.504a3.7 3.7 0 0 1 1.47 1.358q.532.869.532 2.016 0 1.12-.532 2.002a3.8 3.8 0 0 1-1.47 1.372q-.937.504-2.128.504m0-1.792q.546 0 .98-.252t.686-.714q.252-.476.252-1.12 0-.658-.252-1.12a1.8 1.8 0 0 0-.686-.714 1.9 1.9 0 0 0-.98-.252q-.545 0-.98.252a1.9 1.9 0 0 0-.7.714q-.252.462-.252 1.12 0 .644.252 1.12.267.462.7.714.435.252.98.252m9.132 4.508a8 8 0 0 1-2.058-.266q-.98-.252-1.638-.77l.868-1.568q.477.392 1.204.616.742.238 1.456.238 1.163 0 1.68-.518.532-.518.532-1.54v-1.134l.14-1.89-.028-1.904v-1.624h2.072v6.272q0 2.1-1.092 3.094t-3.136.994m-.336-3.192q-1.05 0-1.904-.448a3.7 3.7 0 0 1-1.358-1.274q-.504-.826-.504-1.918 0-1.106.504-1.918a3.56 3.56 0 0 1 1.358-1.274 4.03 4.03 0 0 1 1.904-.448q.952 0 1.68.392.729.378 1.134 1.19.406.798.406 2.058 0 1.246-.406 2.058-.405.798-1.134 1.19t-1.68.392m.434-1.792q.575 0 1.022-.224.448-.238.7-.658a1.84 1.84 0 0 0 .252-.966q0-.56-.252-.966a1.66 1.66 0 0 0-.7-.644 2.14 2.14 0 0 0-1.022-.238q-.573 0-1.022.238a1.77 1.77 0 0 0-.714.644 1.8 1.8 0 0 0-.252.966q0 .546.252.966.267.42.714.658.449.224 1.022.224m6.163 2.156v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.743-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.896 0-1.456.518-.546.504-.546 1.582V223zm10.102 0v-1.47l-.14-.322v-2.632q0-.7-.434-1.092-.42-.392-1.302-.392-.602 0-1.19.196a3 3 0 0 0-.98.504l-.784-1.526q.617-.433 1.484-.672a6.6 6.6 0 0 1 1.764-.238q1.722 0 2.674.812t.952 2.534V223zm-2.296.112q-.882 0-1.512-.294a2.35 2.35 0 0 1-.966-.826 2.1 2.1 0 0 1-.336-1.162q0-.672.322-1.176.336-.504 1.05-.784.714-.294 1.862-.294h2.002v1.274h-1.764q-.77 0-1.064.252a.82.82 0 0 0-.28.63q0 .42.322.672.337.238.91.238.546 0 .98-.252.435-.266.63-.77l.336 1.008a1.95 1.95 0 0 1-.868 1.106q-.63.378-1.624.378m15.963-7.756q.896 0 1.582.364.7.35 1.092 1.092.406.728.406 1.876V223h-2.184v-3.976q0-.91-.378-1.344t-1.064-.434q-.476 0-.854.224-.378.21-.588.644t-.21 1.106V223h-2.184v-3.976q0-.91-.378-1.344-.364-.434-1.05-.434-.476 0-.854.224-.378.21-.588.644t-.21 1.106V223h-2.184v-7.532h2.086v2.058l-.392-.602q.392-.77 1.106-1.162.728-.406 1.652-.406 1.037 0 1.806.532.784.518 1.036 1.596l-.77-.21a3.02 3.02 0 0 1 1.204-1.4q.84-.518 1.918-.518M222.963 223v-7.952h-3.136V213.2h8.54v1.848h-3.136V223zm6.471 0v-7.532h2.184V223zm1.092-8.582q-.603 0-.98-.35a1.14 1.14 0 0 1-.378-.868q0-.518.378-.868.377-.35.98-.35.602 0 .98.336.378.323.378.84 0 .546-.378.91-.365.35-.98.35m6.199 8.694q-1.33 0-2.072-.672-.742-.686-.742-2.03v-6.608h2.184v6.58q0 .476.252.742.252.252.686.252.518 0 .882-.28l.588 1.54q-.336.238-.812.364a4 4 0 0 1-.966.112m-3.976-5.796v-1.68h5.222v1.68zm6.98 5.684v-10.388h2.184V223zm7.949.112q-1.288 0-2.268-.504a3.74 3.74 0 0 1-1.498-1.372q-.532-.882-.532-2.002 0-1.134.518-2.002a3.7 3.7 0 0 1 1.442-1.372q.909-.504 2.058-.504 1.106 0 1.988.476a3.45 3.45 0 0 1 1.414 1.344q.518.868.518 2.086 0 .126-.014.294l-.028.294h-6.118v-1.274h4.97l-.84.378a2.1 2.1 0 0 0-.238-1.022 1.7 1.7 0 0 0-.658-.672 1.87 1.87 0 0 0-.98-.252 1.94 1.94 0 0 0-.994.252q-.42.238-.658.686-.238.434-.238 1.036v.336q0 .617.266 1.092.28.462.77.714.504.238 1.176.238.602 0 1.05-.182.462-.181.84-.546l1.162 1.26q-.519.588-1.302.91-.785.308-1.806.308"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M153.08 241v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V241zm4.672.09q-.45 0-.89-.09a4.3 4.3 0 0 1-.82-.28 2.9 2.9 0 0 1-.68-.47l.32-.67q.48.4.99.58t1.07.18q.48 0 .83-.14.35-.15.54-.43.2-.29.2-.72 0-.62-.41-.94-.411-.32-1.2-.32h-1.05v-.73h.95q.46 0 .8-.15.34-.16.53-.45.19-.3.19-.72 0-.56-.37-.84-.37-.29-1.01-.29-.54 0-1.03.19t-.91.62l-.32-.67a2.7 2.7 0 0 1 1.02-.66q.62-.23 1.28-.23.68 0 1.16.22.489.21.75.62.27.4.27.97 0 .63-.35 1.09a1.8 1.8 0 0 1-.95.64v-.06q.46.08.79.32.33.23.51.59.19.36.19.84 0 .62-.3 1.07-.29.45-.83.69t-1.27.24m6.206 0q-.46 0-.89-.1a3.5 3.5 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59t1.05.19q.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.38.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m6.272-2.41v-.7h2.8v.7zm7.274 2.32v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V241zm4.882.09q-.46 0-.89-.1a3.4 3.4 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59.489.19 1.05.19.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.381.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m5.876 0q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.831 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.399.7 1.23.7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 200h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.03,
    d: "M16 200h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 200h200v72H144z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    filter: "url(#D)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)",
    filter: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M16 280h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M16 280h128v72H16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 280h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 280h200v72H144z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EEE",
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.162 303v-9.8h4.242q1.315 0 2.268.434.952.42 1.47 1.218t.518 1.904q0 1.092-.518 1.89t-1.47 1.232q-.953.42-2.268.42h-2.982l1.008-1.022V303zm2.268-3.472-1.008-1.078h2.856q1.05 0 1.568-.448t.518-1.246q0-.812-.518-1.26t-1.568-.448h-2.856l1.008-1.078zm7.682 3.472v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.741-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.897 0-1.456.518-.546.504-.546 1.582V303zm9.503.112q-1.203 0-2.142-.504a3.9 3.9 0 0 1-1.47-1.372q-.532-.882-.532-2.002 0-1.134.532-2.002a3.8 3.8 0 0 1 1.47-1.372q.939-.504 2.142-.504 1.19 0 2.128.504a3.7 3.7 0 0 1 1.47 1.358q.532.868.532 2.016 0 1.12-.532 2.002a3.8 3.8 0 0 1-1.47 1.372q-.937.504-2.128.504m0-1.792q.546 0 .98-.252t.686-.714q.252-.476.252-1.12 0-.658-.252-1.12a1.8 1.8 0 0 0-.686-.714 1.9 1.9 0 0 0-.98-.252q-.545 0-.98.252a1.9 1.9 0 0 0-.7.714q-.252.462-.252 1.12 0 .644.252 1.12.267.462.7.714.435.252.98.252m9.132 4.508a8 8 0 0 1-2.058-.266q-.98-.252-1.638-.77l.868-1.568q.477.392 1.204.616.742.238 1.456.238 1.163 0 1.68-.518.532-.518.532-1.54v-1.134l.14-1.89-.028-1.904v-1.624h2.072v6.272q0 2.1-1.092 3.094t-3.136.994m-.336-3.192q-1.05 0-1.904-.448a3.7 3.7 0 0 1-1.358-1.274q-.504-.826-.504-1.918 0-1.106.504-1.918a3.56 3.56 0 0 1 1.358-1.274 4.03 4.03 0 0 1 1.904-.448q.952 0 1.68.392.729.378 1.134 1.19.406.798.406 2.058 0 1.247-.406 2.058-.405.798-1.134 1.19t-1.68.392m.434-1.792q.575 0 1.022-.224.448-.238.7-.658a1.84 1.84 0 0 0 .252-.966q0-.56-.252-.966a1.66 1.66 0 0 0-.7-.644 2.14 2.14 0 0 0-1.022-.238q-.573 0-1.022.238a1.77 1.77 0 0 0-.714.644 1.8 1.8 0 0 0-.252.966q0 .546.252.966.267.42.714.658.449.224 1.022.224m6.163 2.156v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.743-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.896 0-1.456.518-.546.504-.546 1.582V303zm10.102 0v-1.47l-.14-.322v-2.632q0-.7-.434-1.092-.42-.392-1.302-.392-.602 0-1.19.196a3 3 0 0 0-.98.504l-.784-1.526q.617-.433 1.484-.672a6.6 6.6 0 0 1 1.764-.238q1.722 0 2.674.812t.952 2.534V303zm-2.296.112q-.882 0-1.512-.294a2.35 2.35 0 0 1-.966-.826 2.1 2.1 0 0 1-.336-1.162q0-.672.322-1.176.336-.504 1.05-.784.714-.294 1.862-.294h2.002v1.274h-1.764q-.77 0-1.064.252a.82.82 0 0 0-.28.63q0 .42.322.672.337.238.91.238.546 0 .98-.252.435-.266.63-.77l.336 1.008a1.95 1.95 0 0 1-.868 1.106q-.63.378-1.624.378m15.963-7.756q.896 0 1.582.364.7.35 1.092 1.092.406.728.406 1.876V303h-2.184v-3.976q0-.91-.378-1.344t-1.064-.434q-.476 0-.854.224-.378.21-.588.644t-.21 1.106V303h-2.184v-3.976q0-.91-.378-1.344-.364-.434-1.05-.434-.476 0-.854.224-.378.21-.588.644t-.21 1.106V303h-2.184v-7.532h2.086v2.058l-.392-.602q.392-.77 1.106-1.162.728-.406 1.652-.406 1.037 0 1.806.532.784.518 1.036 1.596l-.77-.21a3.02 3.02 0 0 1 1.204-1.4q.84-.518 1.918-.518M222.963 303v-7.952h-3.136V293.2h8.54v1.848h-3.136V303zm6.471 0v-7.532h2.184V303zm1.092-8.582q-.603 0-.98-.35a1.14 1.14 0 0 1-.378-.868q0-.518.378-.868.377-.35.98-.35.602 0 .98.336.378.322.378.84 0 .546-.378.91-.365.35-.98.35m6.199 8.694q-1.33 0-2.072-.672-.742-.686-.742-2.03v-6.608h2.184v6.58q0 .476.252.742.252.252.686.252.518 0 .882-.28l.588 1.54q-.336.238-.812.364a4 4 0 0 1-.966.112m-3.976-5.796v-1.68h5.222v1.68zm6.98 5.684v-10.388h2.184V303zm7.949.112q-1.288 0-2.268-.504a3.74 3.74 0 0 1-1.498-1.372q-.532-.882-.532-2.002 0-1.134.518-2.002a3.7 3.7 0 0 1 1.442-1.372q.909-.504 2.058-.504 1.106 0 1.988.476a3.45 3.45 0 0 1 1.414 1.344q.518.868.518 2.086 0 .126-.014.294l-.028.294h-6.118v-1.274h4.97l-.84.378a2.1 2.1 0 0 0-.238-1.022 1.7 1.7 0 0 0-.658-.672 1.87 1.87 0 0 0-.98-.252 1.94 1.94 0 0 0-.994.252q-.42.238-.658.686-.238.434-.238 1.036v.336q0 .616.266 1.092.28.462.77.714.504.238 1.176.238.602 0 1.05-.182.462-.181.84-.546l1.162 1.26q-.519.588-1.302.91-.785.308-1.806.308"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M153.08 321v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V321zm4.672.09q-.45 0-.89-.09a4.3 4.3 0 0 1-.82-.28 2.9 2.9 0 0 1-.68-.47l.32-.67q.48.4.99.58t1.07.18q.48 0 .83-.14.35-.15.54-.43.2-.29.2-.72 0-.62-.41-.94-.411-.32-1.2-.32h-1.05v-.73h.95q.46 0 .8-.15.34-.16.53-.45.19-.3.19-.72 0-.56-.37-.84-.37-.29-1.01-.29-.54 0-1.03.19t-.91.62l-.32-.67a2.7 2.7 0 0 1 1.02-.66q.62-.23 1.28-.23.68 0 1.16.22.489.21.75.62.27.4.27.97 0 .63-.35 1.09a1.8 1.8 0 0 1-.95.64v-.06q.46.08.79.32.33.23.51.59.19.36.19.84 0 .62-.3 1.07-.29.45-.83.69t-1.27.24m6.206 0q-.46 0-.89-.1a3.5 3.5 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59t1.05.19q.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.38.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m6.272-2.41v-.7h2.8v.7zm7.274 2.32v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V321zm4.882.09q-.46 0-.89-.1a3.4 3.4 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59.489.19 1.05.19.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.381.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m5.876 0q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.831 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.399.7 1.23.7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 280h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.03,
    d: "M16 280h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 280h200v72H144z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    filter: "url(#L)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)",
    filter: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M16 360h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M16 360h128v72H16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 360h200v72H144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 360h200v72H144z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EEE",
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.162 383v-9.8h4.242q1.315 0 2.268.434.952.42 1.47 1.218t.518 1.904q0 1.092-.518 1.89t-1.47 1.232q-.953.42-2.268.42h-2.982l1.008-1.022V383zm2.268-3.472-1.008-1.078h2.856q1.05 0 1.568-.448t.518-1.246q0-.812-.518-1.26t-1.568-.448h-2.856l1.008-1.078zm7.682 3.472v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.741-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.897 0-1.456.518-.546.504-.546 1.582V383zm9.503.112q-1.203 0-2.142-.504a3.9 3.9 0 0 1-1.47-1.372q-.532-.882-.532-2.002 0-1.134.532-2.002a3.8 3.8 0 0 1 1.47-1.372q.939-.504 2.142-.504 1.19 0 2.128.504a3.7 3.7 0 0 1 1.47 1.358q.532.868.532 2.016 0 1.12-.532 2.002a3.8 3.8 0 0 1-1.47 1.372q-.937.504-2.128.504m0-1.792q.546 0 .98-.252t.686-.714q.252-.476.252-1.12 0-.658-.252-1.12a1.8 1.8 0 0 0-.686-.714 1.9 1.9 0 0 0-.98-.252q-.545 0-.98.252a1.9 1.9 0 0 0-.7.714q-.252.462-.252 1.12 0 .644.252 1.12.267.462.7.714.435.252.98.252m9.132 4.508a8 8 0 0 1-2.058-.266q-.98-.252-1.638-.77l.868-1.568q.477.392 1.204.616.742.238 1.456.238 1.163 0 1.68-.518.532-.518.532-1.54v-1.134l.14-1.89-.028-1.904v-1.624h2.072v6.272q0 2.1-1.092 3.094t-3.136.994m-.336-3.192q-1.05 0-1.904-.448a3.7 3.7 0 0 1-1.358-1.274q-.504-.826-.504-1.918 0-1.106.504-1.918a3.56 3.56 0 0 1 1.358-1.274 4.03 4.03 0 0 1 1.904-.448q.952 0 1.68.392.729.378 1.134 1.19.406.798.406 2.058 0 1.247-.406 2.058-.405.798-1.134 1.19t-1.68.392m.434-1.792q.575 0 1.022-.224.448-.238.7-.658a1.84 1.84 0 0 0 .252-.966q0-.56-.252-.966a1.66 1.66 0 0 0-.7-.644 2.14 2.14 0 0 0-1.022-.238q-.573 0-1.022.238a1.77 1.77 0 0 0-.714.644 1.8 1.8 0 0 0-.252.966q0 .546.252.966.267.42.714.658.449.224 1.022.224m6.163 2.156v-7.532h2.086v2.128l-.294-.616a2.4 2.4 0 0 1 1.078-1.204q.743-.42 1.806-.42v2.016a3 3 0 0 0-.252-.014 2 2 0 0 0-.238-.014q-.896 0-1.456.518-.546.504-.546 1.582V383zm10.102 0v-1.47l-.14-.322v-2.632q0-.7-.434-1.092-.42-.392-1.302-.392-.602 0-1.19.196a3 3 0 0 0-.98.504l-.784-1.526q.617-.434 1.484-.672a6.6 6.6 0 0 1 1.764-.238q1.722 0 2.674.812t.952 2.534V383zm-2.296.112q-.882 0-1.512-.294a2.35 2.35 0 0 1-.966-.826 2.1 2.1 0 0 1-.336-1.162q0-.672.322-1.176.336-.504 1.05-.784.714-.294 1.862-.294h2.002v1.274h-1.764q-.77 0-1.064.252a.82.82 0 0 0-.28.63q0 .42.322.672.337.238.91.238.546 0 .98-.252.435-.266.63-.77l.336 1.008a1.95 1.95 0 0 1-.868 1.106q-.63.378-1.624.378m15.963-7.756q.896 0 1.582.364.7.35 1.092 1.092.406.728.406 1.876V383h-2.184v-3.976q0-.91-.378-1.344t-1.064-.434q-.476 0-.854.224-.378.21-.588.644t-.21 1.106V383h-2.184v-3.976q0-.91-.378-1.344-.364-.434-1.05-.434-.476 0-.854.224-.378.21-.588.644t-.21 1.106V383h-2.184v-7.532h2.086v2.058l-.392-.602q.392-.77 1.106-1.162.728-.406 1.652-.406 1.037 0 1.806.532.784.518 1.036 1.596l-.77-.21a3.02 3.02 0 0 1 1.204-1.4q.84-.518 1.918-.518M222.963 383v-7.952h-3.136V373.2h8.54v1.848h-3.136V383zm6.471 0v-7.532h2.184V383zm1.092-8.582q-.603 0-.98-.35a1.14 1.14 0 0 1-.378-.868q0-.518.378-.868.377-.35.98-.35.602 0 .98.336.378.322.378.84 0 .546-.378.91-.365.35-.98.35m6.199 8.694q-1.33 0-2.072-.672-.742-.686-.742-2.03v-6.608h2.184v6.58q0 .476.252.742.252.252.686.252.518 0 .882-.28l.588 1.54q-.336.238-.812.364a4 4 0 0 1-.966.112m-3.976-5.796v-1.68h5.222v1.68zm6.98 5.684v-10.388h2.184V383zm7.949.112q-1.288 0-2.268-.504a3.74 3.74 0 0 1-1.498-1.372q-.532-.882-.532-2.002 0-1.134.518-2.002a3.7 3.7 0 0 1 1.442-1.372q.909-.504 2.058-.504 1.106 0 1.988.476a3.45 3.45 0 0 1 1.414 1.344q.518.868.518 2.086 0 .126-.014.294l-.028.294h-6.118v-1.274h4.97l-.84.378a2.1 2.1 0 0 0-.238-1.022 1.7 1.7 0 0 0-.658-.672 1.87 1.87 0 0 0-.98-.252 1.94 1.94 0 0 0-.994.252q-.42.238-.658.686-.238.434-.238 1.036v.336q0 .616.266 1.092.28.462.77.714.504.238 1.176.238.602 0 1.05-.182.462-.181.84-.546l1.162 1.26q-.519.588-1.302.91-.785.308-1.806.308"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M153.08 401v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V401zm4.672.09q-.45 0-.89-.09a4.3 4.3 0 0 1-.82-.28 2.9 2.9 0 0 1-.68-.47l.32-.67q.48.4.99.58t1.07.18q.48 0 .83-.14.35-.15.54-.43.2-.29.2-.72 0-.62-.41-.94-.411-.32-1.2-.32h-1.05v-.73h.95q.46 0 .8-.15.34-.16.53-.45.19-.3.19-.72 0-.56-.37-.84-.37-.29-1.01-.29-.54 0-1.03.19t-.91.62l-.32-.67a2.7 2.7 0 0 1 1.02-.66q.62-.23 1.28-.23.68 0 1.16.22.489.21.75.62.27.4.27.97 0 .63-.35 1.09a1.8 1.8 0 0 1-.95.64v-.06q.46.08.79.32.33.23.51.59.19.36.19.84 0 .62-.3 1.07-.29.45-.83.69t-1.27.24m6.206 0q-.46 0-.89-.1a3.5 3.5 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59t1.05.19q.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.38.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m6.272-2.41v-.7h2.8v.7zm7.274 2.32v-.73h1.77v-5.61l.45.03-1.87 1.2-.38-.65 2.03-1.29h.62v6.32h1.64v.73zm7.916.09q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.83 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.4.7 1.23.7m3.666-3.21v-1.04h1.09v1.04zm0 3.86v-1.05h1.09V401zm4.882.09q-.46 0-.89-.1a3.4 3.4 0 0 1-.8-.29 3 3 0 0 1-.66-.46l.33-.68q.47.4.96.59.489.19 1.05.19.74 0 1.15-.4.42-.4.42-1.08 0-.69-.4-1.12-.39-.43-1.08-.43-.49 0-.87.2-.381.19-.69.63h-.65v-4.19h4.15v.74h-3.34v2.72h-.14a1.8 1.8 0 0 1 .69-.6q.44-.23.99-.23.67 0 1.16.28t.75.78q.27.5.27 1.17 0 .69-.3 1.2-.29.51-.83.8-.53.28-1.27.28m5.876 0q-.81 0-1.37-.41-.55-.42-.83-1.22-.28-.81-.28-1.99t.28-1.98q.28-.81.83-1.22.56-.41 1.37-.41.82 0 1.37.41t.83 1.21.28 1.98-.28 1.99-.84 1.23q-.55.41-1.36.41m0-.74q.83 0 1.23-.7.4-.71.4-2.19t-.4-2.17q-.39-.69-1.23-.69-.831 0-1.23.7-.4.69-.4 2.17 0 1.47.4 2.18.399.7 1.23.7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 360h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.03,
    d: "M16 360h128v72H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M144 360h200v72H144z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 40h360v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 72,
    x: 16,
    y: 40,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 40h128v72H16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 40h128v72H16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 48h152v36H152z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 120h360v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 72,
    x: 16,
    y: 120,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 120h128v72H16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 128h184v36H152z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 200h360v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 72,
    x: 16,
    y: 200,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 200h128v72H16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 208h184v36H152z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 280h360v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 72,
    x: 16,
    y: 280,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 280h128v72H16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 288h184v36H152z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 360h360v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 72,
    x: 16,
    y: 360,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 360h128v72H16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 368h184v36H152z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "f",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4504_7418",
    transform: "matrix(.00083 0 0 .00148 0 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "o",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4504_7418",
    transform: "matrix(.00083 0 0 .00148 0 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "p",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_4504_7418",
    transform: "matrix(.0009 0 0 .00159 .002 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "q",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_4504_7418",
    transform: "matrix(.0003 0 0 .00046 -.13 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_4504_7418",
    transform: "scale(.00033 .0006)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "y",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4504_7418",
    transform: "matrix(.00083 0 0 .00148 0 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_4504_7418",
    transform: "matrix(.00027 0 0 .00048 -.058 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "A",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_4504_7418",
    transform: "scale(.00026 .00046)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "H",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4504_7418",
    transform: "matrix(.00083 0 0 .00148 0 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "I",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_4504_7418",
    transform: "scale(.00026 .00046)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "P",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4504_7418",
    transform: "matrix(.00083 0 0 .00148 0 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Q",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_4504_7418",
    transform: "matrix(.00027 0 0 .00048 -.058 0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 344,
    height: 88,
    x: 8,
    y: 36,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 132,
    height: 80,
    x: 14,
    y: 39,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4504_7418",
    result: "effect2_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_4504_7418",
    result: "effect3_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_4504_7418",
    result: "effect4_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_4504_7418",
    result: "effect5_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 344,
    height: 88,
    x: 8,
    y: 116,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: 132,
    height: 80,
    x: 14,
    y: 119,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4504_7418",
    result: "effect2_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_4504_7418",
    result: "effect3_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_4504_7418",
    result: "effect4_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_4504_7418",
    result: "effect5_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 344,
    height: 88,
    x: 8,
    y: 196,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "x",
    width: 132,
    height: 80,
    x: 14,
    y: 199,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4504_7418",
    result: "effect2_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_4504_7418",
    result: "effect3_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_4504_7418",
    result: "effect4_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_4504_7418",
    result: "effect5_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "D",
    width: 344,
    height: 88,
    x: 8,
    y: 276,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "G",
    width: 132,
    height: 80,
    x: 14,
    y: 279,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4504_7418",
    result: "effect2_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_4504_7418",
    result: "effect3_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_4504_7418",
    result: "effect4_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_4504_7418",
    result: "effect5_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "L",
    width: 344,
    height: 88,
    x: 8,
    y: 356,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "O",
    width: 132,
    height: 80,
    x: 14,
    y: 359,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4504_7418",
    result: "effect2_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_4504_7418",
    result: "effect3_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_4504_7418",
    result: "effect4_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_4504_7418",
    result: "effect5_dropShadow_4504_7418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_4504_7418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 87.111,
    x2: 87.111,
    y1: 112,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopOpacity: 0.964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.918
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopOpacity: 0.853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopOpacity: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopOpacity: 0.557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopOpacity: 0.232
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopOpacity: 0.036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};
export default SvgEpgListSkeletonMobile;